export const CurrencyFormat=(number,decimalnumber=0, currencyCode = 'USD', locale = 'en-US')=>{
    try {
        const formattedCurrency = new Intl.NumberFormat(locale, {
          style: 'currency',
          currency: currencyCode,
          minimumFractionDigits: decimalnumber,
          maximumFractionDigits: decimalnumber,
        }).format(number);
    
        return formattedCurrency;
      } catch (error) {
        console.error('Error formatting currency:', error);
        return 'Error';
      }
}